import { Button as MuiButton, type ButtonProps as MuiButtonProps } from '@mui/material';
import { useForkRef } from '@mui/material/utils';
import { type AnchorHTMLAttributes, forwardRef } from 'react';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';

type Props = WithoutStyleOverrides<Omit<MuiButtonProps, 'ref'>>
  & Pick<AnchorHTMLAttributes<HTMLAnchorElement>, 'target' | 'rel' | 'download'>;

// forwardRef, not a `ref` prop: the app still runs React 18, where function components never receive `ref`.
export const Button = forwardRef<HTMLElement, Props>(function Button(props, ref) {
  const elementRef = useForkRef(ref);
  return <MuiButton {...props} ref={elementRef} />;
});

export type { Props as ButtonProps };
